export default () => {
  window.zE('webWidget', 'show');
  window.zE('webWidget', 'open');
};
